import commons from '../../../components/commons';
import useBannerNavigation from 'legacyfrontend/hooks/useBannerNavigation';
import { useAmenitiesIcons } from 'legacyfrontend/hooks/packages';
import EmpresaBannerCard from 'frontend/features/banners/components/EmpresaBannerCard';
import { isV1Banner } from 'frontend/features/banners';

export default function FullWidthBanner({ data }) {
  const { getNavigationProps } = useBannerNavigation();
  const [getIcon] = useAmenitiesIcons();
  const { banner, categoria } = data;
  const firstBanner = banner[0];

  if (isV1Banner(firstBanner)) {
    const template = Number(firstBanner.template) || 4;
    return (
      <div className='container mb-8 md:mb-12'>
        <h3 className='fullWidthBanner-title text-gray-600 mb-3'>{categoria.descripcion}</h3>
        <div className='grid grid-cols-1'>
          <EmpresaBannerCard data={firstBanner} templateOverride={template} />
        </div>
      </div>
    );
  }

  const {
    title,
    description,
    price,
    manualPrice,
    services,
    tag,
    descuento,
    mostrarTitulo,
    mostrarDescripcion,
    mostrarPrecio,
    mostrarDescuento,
    mostrarExtra,
    imagenMobile,
  } = firstBanner;

  const textTest = title;
  const textDescription = description;
  const biyu = price === null ? manualPrice : price;
  const desktopImg = commons.imgUrlValidator(firstBanner.imageUrl);
  const mobileImg = commons.imgUrlValidator(imagenMobile || firstBanner.imageUrl);
  const navigationProps = getNavigationProps(firstBanner);

  const renderAmenitiesIcons =
    services &&
    services.map((serviceKeyName) => (
      <span key={`${title}-service-${serviceKeyName}`} className='mr-2'>
        <i className={getIcon(serviceKeyName)} />
      </span>
    ));

  const hasTextContent = (!mostrarTitulo && title) || (!mostrarDescripcion && description);
  const hasPriceContent = !mostrarPrecio && biyu;
  const hasAmenitiesContent = !mostrarExtra && renderAmenitiesIcons;
  const hasTagContent = (!mostrarExtra && tag?.trim()) || 
                       (!mostrarPrecio && manualPrice?.trim()) || 
                       (!mostrarDescuento && descuento?.trim());
  
  const hasContent = hasTextContent || hasPriceContent || hasAmenitiesContent || hasTagContent;

  return (
    <div className='container mb-8 md:mb-12'>
      <h3 className='fullWidthBanner-title text-gray-600 mb-3'>{categoria.descripcion}</h3>
      <div className='grid  grid-cols-1 '>
        <div key={textTest} className='banner-container no-video'>
          <a
            className='block transition duration-500 shadow-sm hover:shadow-lg'
            href={navigationProps.href}
            target={navigationProps.target}
            rel='noreferrer'
          >
            <div className='relative'>
              <picture>
                <source media='(max-width: 768px)' srcSet={mobileImg} />
                <img className='FullWidthBanner_img' src={desktopImg} alt={title || categoria.descripcion} />
              </picture>
              {hasTagContent && (
                <div className='banner_tag-amenities'>
                  {!mostrarExtra && tag?.trim() && (
                    <div className='banner_tag'>{tag}</div>
                  )}
                  {!mostrarPrecio && manualPrice?.trim() && (
                    <div className='banner_tag_price'>{manualPrice}</div>
                  )}
                  {!mostrarDescuento && descuento?.trim() && (
                    <div className='banner_discount'>{descuento}</div>
                  )}
                </div>
              )}
            </div>
            {hasContent && (
              <div className='banner-content'>
                {hasTextContent && (
                  <div className='flex justify-between items-center p-3'>
                    <div className='text-information'>
                      {!mostrarTitulo && title && (
                        <div className='banner_info-title'>{title}</div>
                      )}
                      {!mostrarDescripcion && description && (
                        <div className='banner_info-description'>{description}</div>
                      )}
                    </div>
                  </div>
                )}
                {hasPriceContent && (
                  <div className='banner-price'>
                    <span className='price-text'>{biyu}</span>
                  </div>
                )}
                {hasAmenitiesContent && (
                  <div className='banner-amenities'>{renderAmenitiesIcons}</div>
                )}
              </div>
            )}
          </a>
        </div>
      </div>
    </div>
  );
}
